/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blocked_PrefixInputs */

const en_blocked_prefix = /** @type {(inputs: Blocked_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked: `)
};

const es_blocked_prefix = /** @type {(inputs: Blocked_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado: `)
};

/**
* | output |
* | --- |
* | "Blocked:" |
*
* @param {Blocked_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const blocked_prefix = /** @type {((inputs?: Blocked_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocked_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blocked_prefix(inputs)
	return es_blocked_prefix(inputs)
});